
const PermissionsPlugin = {
  install(Vue, options) {
    Vue.prototype.$hasPermission = function (name) {
      return this.$store.getters['accountModule/hasPermission'](name)
    };
  }
};

export default PermissionsPlugin;
